import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrFactSheetMaterialComponent } from './kn-br-fact-sheet-material.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrFactSheetMaterialComponent: {
                    component: () => import('./kn-br-fact-sheet-material.component').then((c) => c.KnBrFactSheetMaterialComponent),
                },
            },
        } as CmsConfig),
        KnBrFactSheetMaterialComponent,
    ],
})
export class KnBrFactSheetMaterialModule { }
